import { render, staticRenderFns } from "./smFeeregistInitAction.vue?vue&type=template&id=c4a22ab0&scoped=true"
import script from "./smFeeregistInitAction.vue?vue&type=script&lang=js"
export * from "./smFeeregistInitAction.vue?vue&type=script&lang=js"
import style0 from "./smFeeregistInitAction.vue?vue&type=style&index=0&id=c4a22ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a22ab0",
  null
  
)

export default component.exports